<template>
  <div class="lotteryHomeCard">
    <div class="row">
      <div class="img-wrapper">
        <div class="responsive-img">
          <img class="icon" :src="require(`@/img/ballIcon/${ lotteryConfig[lotteryCode].imgUrl}`)">
        </div>
      </div>

      <div class="period-info">
        <div class="row">
          <div>第<span class="red"> {{currentperiod}} </span>期</div>
          <div>下期开奖 <span class="red">{{nextperiod}} </span></div>
        </div>


        <div class="draw_number row">
          <div class="drawballs"
               :class="evenTenColumn.includes(lotteryCode) ? 'evenTenColumn' : ''"
               v-show="lotteryCode !='xglhc' && lotteryCode !='kl8lhc' && lotteryCode !='twbglhc' ">
            <template v-if="lotteryCode !='lucky7daily'"><!--英國天天除外-->
              <div
                v-for="(item,index) in lastDraw"

                :class="`${lotteryCode} ball ball-${parseInt(item)} ${LotteryTwenty.includes(lotteryCode) ? 'twentyBall' : '' }`"
                :key="index">
                <span v-if="padLeftLottery.includes(lotteryCode)">{{item | padLeft(2)}}</span>
                <span v-else-if="padLeftLottery2.includes(lotteryCode)">{{parseInt(item)}}</span>
                <span v-else>{{item}}</span>
              </div>
            </template>
            <template v-else>
                <template v-if="lastDraw[0] == ''">
                    <div :class="`${lotteryCode} ball ball-99`" v-for="(item,index) in 7" :key="index+'_3'">
                        <span> ? </span>
                    </div>
                </template>
                <template v-else>
                    <div :class="`${lotteryCode} ball ball-${item}`" v-for="(item,index) in lastDraw.slice(0, 6)" :key="index">
                        <span v-if="padLeftLottery.includes(lotteryCode)">{{item | padLeft(2)}}</span>
                    </div>
                    <div class="add" v-if='lastDraw.length === 7'> + </div>
                    <div :class="`${lotteryCode} ball ball-${parseInt(lastDraw[6])}`"  v-if='lastDraw.length === 7'>{{lastDraw[6] | padLeft(2)}}</div>
                    <div :class="`${lotteryCode} ball ball-99`" v-for="(item,index) in 7- lastDraw.length" :key="index+'_2'">
                        <span> ? </span>
                    </div>
                </template>
            </template>
          </div>
          <!--- 六合系列 -->
          <div v-if="lastDraw.length > 0" class="drawballs" v-show="lotteryCode==='xglhc' || lotteryCode==='kl8lhc' || lotteryCode==='twbglhc' ">
            <div :class="`${lotteryCode} ball ball-${lastDraw[index]}`" v-for="(item,index) in 6" :key="index">{{lastDraw[index] | padLeft(2)}}</div>
            <div class="add"> + </div>
            <div :class="`${lotteryCode} ball ball-${parseInt(lastDraw[6])}`">{{lastDraw[6] | padLeft(2)}}</div>
          </div>
          <!-- 5分彩 -->
        </div>
        <LhcTable v-if="lotteryCode=='xglhc' || lotteryCode=='kl8lhc' || lotteryCode=='twbglhc'" :lastperiod="tableData" :lotteryCode="lotteryCode" />
        <DefaultTable v-else-if="lotteryCode=='qxc'" :lastperiod="tableData" :lotteryCode="lotteryCode" />

      </div>

    </div>

    <div class="row lotterycard-action">
      <div class="countdown row"  v-if="lotteryDrawTime[lotteryCode]>0">
        <div class="time_block" v-if="lotteryConfig[lotteryCode].lotteryType==1">

          {{lotteryDrawTime[lotteryCode] | reciprocalDay}}
          <p>天</p>
        </div>
        <div class="time_block" v-if="lotteryConfig[lotteryCode].lotteryType==1">
          {{lotteryDrawTime[lotteryCode] | reciprocalHour}}
          <p>时</p>
        </div>
        <div class="time_block">
          {{lotteryDrawTime[lotteryCode] | reciprocalMinute}}
          <p>分</p>
        </div>
        <div class="time_block">
          {{lotteryDrawTime[lotteryCode] | reciprocalSecond}}
          <p>秒</p>
        </div>
      </div>
     
      <div class="countdown"  style="align-items: center" v-else>
        <div class="icon"><img class="rotating" src="@/img/H5/return-1.png">开奖中...</div>
      </div>
      <!-- 圖紙圖庫按鈕-英國天天彩 -->
        <div class="imageLibBtn"  v-if="lotteryCode=='xglhc'||lotteryCode=='lucky7daily'||lotteryCode=='kl8lhc'||lotteryCode=='twgblhc'">
          <a class="item" @click="()=>{this.$router.push({path:`/mobile/lottery/${lotteryCode}`,query:{currentTab:'imageLib'} })}">
              <img src="@/img/H5/imageLib-button.png">
          </a>
      </div>
      <a class="item active" :class="{active: isActive}" @click="`${isActive=!isActive}`" :href="`/#/mobile/lottery/${lotteryCode}`" ><img src="@/img/H5/statistics.png"/>开奖历史</a>
      <div @click="openLiveStream" class="VideoBtn" v-if='lotteryCode !="kl8lhc"'>
          <a class="item" :class="lotteryConfig[lotteryCode].liveStream ? 'active': ''" style="pointer-events: none;">
              <img :src="require(lotteryConfig[lotteryCode].liveStream ? '@/img/H5/play-button.png' : '@/img/H5/play-button-close.png')"/>开奖视频
          </a>
      </div>
      <a class='launch-kl8-website active' v-else href='https://www.cwl.gov.cn/ygkj/kjzb/' target='_blank' rel='noopener noreferrer'>
        <img src='@/img/H5/play-button.png' />开奖验证
      </a>
    </div>
  </div>
</template>
<script>
import {mapState, mapGetters, mapActions } from 'vuex';
import {lotteryConfig} from "@/assets/lotteryConfig.js";
import DefaultTable from '@/components/H5/default_home_table.vue'
import LhcTable from '@/components/H5/lhc_home_table.vue'
import path from 'path';
export default {
  name: 'lotteryHomeCard',
  props: {
    lotteryCode: String,
  },
  components: {
        DefaultTable,
        LhcTable,
  },
  data() {
    return{
      nextperiod:{},
      currentperiod: {},
      lastDraw: [],
      lotteryConfig: lotteryConfig,
      tableData: [],
      isActive: false,
      padLeftLottery: ['azxy8','jisukuaile','lucky7daily', 'infinity8', 'infinity8ex', 'cannon20', 'cannon20ex', 'lucky5', 'lucky5ex', 'xglhc', 'kl8lhc'],
      LotteryTwenty:['cannon20','azxy20','cannon20ex'],
      evenTenColumn: ['twbg'],
      padLeftLottery2: ['azxy10','azxy20','jisusaiche']
    }
  },
  computed: {
    ...mapState([
      "baseInfo",
      "lotteryDrawTime"
    ]),
  },
  watch: {
    baseInfo: {
      handler: function(value){

        this.setLotteryInfo(this.lotteryCode);
      },
      immediate: true,
      deep: true,
    }
  },
  methods: {
    setLotteryInfo: function(lotteryCode) {

      if(!this.baseInfo[lotteryCode]) {
        return;
      }

      let lotteryInfo = this.baseInfo[lotteryCode];
      let lastperiodInfo = this.baseInfo[lotteryCode].last_period;
      this.lotteryName = lotteryInfo.name; // 樂透名
      if(lotteryInfo) {
        this.nextperiod = lotteryInfo.current_period.period_no;
        this.currentperiod = lotteryInfo.last_period.period_no;
        this.lastDraw = this.$options.filters.splitDrawNumber(lastperiodInfo.draw.split(","),this.lotteryCode);
        this.tableData = lastperiodInfo;
      }
    },
    openLiveStream: function(){
        if(!this.lotteryConfig[this.lotteryCode].liveStream ){
            return false;
        } else {
            this.$emit('openVedio', this.lotteryCode, this.baseInfo[this.lotteryCode]);
        }
    }
  },
}
</script>
<style scoped lang="scss" >

.row{display:flex;flex-direction:row;margin: 13px 8px;justify-content: space-between}
.ball{width:20px;height:20px;}
.red{color:#f00;}
.lotteryHomeCard{
  width: 100%;
  display: flex;
  flex-direction:column;
  margin-bottom: 10px;
  background-color: #fff;
  padding: 0;
  border-radius:5px;
  box-shadow: 1px 1px 16px 1px rgba(0,0,0,0.15);
  overflow: hidden;
}
.lotterycard-action{
  background:#e9bf95;
  color:#5d2d00;
  margin:0;
  gap:0;
}
.img-wrapper{
  width:70px;
  margin-right:10px;
  @media(min-width:768px){
    width:120px;
  }
}
.responsive-img{
  position:relative;
  height:0;
  padding-bottom:100%;
}
img.icon{
  position:absolute;
  width:100%;
  height:100%;
}
.period-info{
  display:flex;
  flex-direction:column;
  flex:1;
  color:#5d2d00;
  font-size:12px;
  .row{
    margin:0;
    flex:1;
    justify-content: center;
    &:first-of-type{flex-grow:0;}
    > div{
      width:50%;
    }
  }
  .draw_number{
    justify-content: flex-start;
    align-items:center;
    -webkit-align-items: center;
  }
  .drawballs{
    grid-gap:3px;
    margin-top:8px;
  }
  @media(min-width:400px){
    .drawballs{
      grid-gap:4px;
    }
  }
}


.lotterycard-action{
  display:flex;
  justify-content:center;
  font-size:10px;
  @media(min-width:400px){
    font-size:12px;
  }
  .countdown{
    display:flex;justify-content: flex-start;
    margin:10px auto 10px 5px;
    flex-basis:105px;
    p{margin:4px 0;}
    .time_block{
      width:28px;
      height:28px;
      text-align:center;
      position:relative;
      &:after{
        position:absolute;
        width:4px;height:28px;
        content:':';
        right:0;
        top:-1px;
        display:block;
      }
      &:last-of-type:after{display:none;}
    }
  }
  .icon, .item{
    align-items: center;display:flex;
    -webkit-align-items: center;
    }
  .icon img{margin:0 5px;}
  img{margin-right:3px;}
  .item{
    padding:2px 0;
    justify-content: center;
    flex-basis: 80px;
    color: #CEA279;
    border-left:1px solid #edccaa;
    &.active{
        color: #5d2d00;;
    }
    @media(min-width:400px){flex-basis: 90px;}
  }
  .imageLibBtn{
    display: flex;
    flex-basis: 70px;
    a{
      border:0;
    }
    img{
      margin: 0;
      width: 60px;
    }
    @media(min-width:400px){
      flex-basis: 80px;
      img{
        margin: 0;
        width: 70px;
      }
    }
  }
}

.ball-99{
    background: #505050
}

.VideoBtn{
  display: flex;
  flex-basis:75px;
  justify-content: center;
    .item{
      flex-basis:75px;
        &.active{
            color: #5d2d00;;
        }
    }
  @media(min-width:400px){
    flex-basis: 85px;
    .item{
      flex-basis:85px;
    }
  }
}
.launch-kl8-website{
  background-color: #ffc97b!important;
  flex-basis:75px!important;display:flex;justify-content: center;align-items: center;
  @media(min-width:400px){
    flex-basis: 85px!important;
  }
}
.launch-kl8-website img{align-self: center;margin-right:3px;}
</style>